import root from 'window-or-global';
const domain = root.location.host;

export default (domain == "0-0-0-0.nip.io:8080");
